import React, { useEffect, useRef, useState, useCallback } from 'react';
import { TreeView } from 'onefaceui-react-components';
import { BaseField } from 'react/components/fields';
import PropTypes from 'prop-types';
import { batch } from 'react-redux';
import { TreeViewContainer } from './styles';

const handleOnSelectValues = (selectedValues, input) => {
    let updatedOrganizations = input.value && input.value.reduce((accumulatedOrganizations, surveyOrganization) => {
        if (surveyOrganization.id) {
            accumulatedOrganizations.push({
                ...surveyOrganization,
                removed: !selectedValues.includes(surveyOrganization.organization.id),
            });
        }
        return accumulatedOrganizations;
    }, []) || [];

    selectedValues.forEach(selectedValue => {
        if (!updatedOrganizations.some(surveyOrganization => surveyOrganization.organization.id === selectedValue)) {
            updatedOrganizations.push({ organization: { id: selectedValue } });
        }
    });
    batch(() => {
        input.onBlur();
        input.onChange(updatedOrganizations);
    });
};

const formatToTreeViewSelect = values => values && values.filter(value => value?.organization?.id && !value.removed)
    .map(value => value.organization.id) || [];

const OrganizationTreeView = (props) => {
    const { surveyOrganizations, organization, organizationsHierarchy } = props;
    const organizationsHierarchyData = Greenmile.Survey.Data.formatToTreeViewData(organizationsHierarchy);
    const legacySurveyOrganizations = organization ? Greenmile.Survey.Data.findOrganizationDescendants(organizationsHierarchyData, organization.id) : [];
    const [initialValues, setInicialValues] = useState([
        ...formatToTreeViewSelect(surveyOrganizations),
        ...legacySurveyOrganizations
    ]);
    const initialValuesLoaded = useRef(false);

    useEffect(() => {
        if ((surveyOrganizations.length || organization) && !initialValuesLoaded.current) {
            setInicialValues([
                ...formatToTreeViewSelect(surveyOrganizations),
                ...legacySurveyOrganizations
            ]);
            initialValuesLoaded.current = true;
        }
    }, [surveyOrganizations, organization, organizationsHierarchyData, legacySurveyOrganizations]);

    const renderFieldContent = useCallback(({ id, input }) => {
        return (
            <TreeViewContainer className='organizationTreeViewContainer' id={id}>
                <TreeView
                    id={id}
                    input={input}
                    data={organizationsHierarchyData}
                    selectable={true}
                    initialValues={initialValues}
                    onSelectValues={(values) => handleOnSelectValues(values, input)}
                />
            </TreeViewContainer>
        );
    }, [organizationsHierarchyData, initialValues]);

    const gridFormatter = ({
        label,
        name,
        lookupEntity,
        lookupEntityColumn,
        monetMeta }) => {

        return {
            id: name,
            name,
            label,
            type: 'LOOKUP_LIST',
            lookupEntity,
            lookupEntityColumn,
            meta: monetMeta
        };
    };

    const customValidation = (values) => {
        const { required } = props;
        const valuesFiltered = values && values.filter(value => !value.removed);
        return required && !valuesFiltered?.length ? 'general.mandatoryField' : undefined;
    };

    return <BaseField gridFormatter={gridFormatter} fieldClassName="treeViewField" renderFieldContent={renderFieldContent} customValidation={customValidation} {...props} />;
};

OrganizationTreeView.propTypes = {
    id: PropTypes.string.isRequired,
    input: PropTypes.object.isRequired,
    surveyOrganizations: PropTypes.array,
    organizationsHierarchy: PropTypes.array.isRequired,
    required: PropTypes.bool,
    organization: PropTypes.shape({
        id: PropTypes.string
    }),
};

OrganizationTreeView.defaultProps = {
    surveyOrganizations: [],
    required: false,
};

export default OrganizationTreeView;